import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { UiConfig } from '@calendly/ui/config';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SearchFilter } from 'features/scheduling/search/search_filter';
import { customBreakpoints } from '../shared';
import { List } from './list';
const listWrapperCss = "l13h4rtk";
const ListWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(listWrapperCss, props.className)} />;
});
export const SingleUseLinks = () => {
  const sulTitle = I18n.t('publisher.home.scheduling_subsection.tabs.single_use_links');
  const schedulingTitle = I18n.t('publisher.home.page_header.scheduling');
  usePageTitle(`${sulTitle} - ${schedulingTitle} - Calendly`);
  return <UiConfig breakpoints={customBreakpoints}>
      <SearchFilter />
      <ListWrapper data-component="Single use link tab content">
        <List />
      </ListWrapper>
    </UiConfig>;
};

require("./single_use_links.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./single_use_links.js");